export type CreatePartnerRequest = {
  ptnrCd: string;
  ptnrName: string;
  ptnrTypeCd: string;
  buCnTypeCd: string;
  buCd: string;
  cnCd: string;
  dipByRgn: string;
  cpntId: string;
  chnTypeList: CreateChnType[];
};

export type CreateChnType = {
  inOutTypeCd: string;
  chnTypeCd: string;
  fileTypeCd: string;
};
